import { StateNode } from '@ansys-internal/awf-angular/store';
import { ConfigurationEnvironment } from 'src/app/shared/services/configurations.service';

export class ConfigurationEnvState
  implements StateNode<ConfigurationEnvironment>
{
  key: string = 'configurationEnv';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => ConfigurationEnvironment = () => {
    return {
      gradient: 0,
      speed: 50,
      acceleration: 0,
      altitude: 0,
      headwind: 0,
      stepsize: 0.2,
    };
  };
}
